<template>
  <div class="commentList">
    <el-form ref="params" :model="commentParam" label-width="auto">
      <el-row :gutter="12">
        <el-col :span="4">
          <el-form-item label="视频ID" style="margin-bottom: 0">
            <el-input
              placeholder="请输入视频ID"
              size="small"
              class="param-input"
              style="width: 100%"
              v-model="commentParam.vidID"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="用户UID" style="margin-bottom: 0">
            <el-input
              placeholder="请输入用户UID"
              size="small"
              class="param-input"
              style="width: 100%"
              v-model="commentParam.uid"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="评论内容" style="margin-bottom: 0">
            <el-input
              placeholder="请输入评论内容"
              size="small"
              class="param-input"
              style="width: 100%"
              v-model="commentParam.content"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="false">
          <el-form-item label="是否是机器人" style="margin-bottom: 0">
            <el-select
              v-model.number="commentParam.isRobot"
              size="small"
              @change="getCommentList(commentParam, 'status')"
              placeholder="是否是机器人"
              style="width: 100%"
            >
              <el-option
                v-for="item in robotlist"
                :value="item.value"
                :label="item.label"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="是否置顶" style="margin-bottom: 0">
            <el-select
              v-model.number="commentParam.pinned"
              size="small"
              placeholder="是否置顶"
              style="width: 100%"
            >
              <el-option :value="Boolean(null)" label="否"
                >--是否置顶--</el-option
              >
              <el-option :value="Boolean(false)" label="否"></el-option>
              <el-option :value="Boolean(true)" label="是"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="评论层级" style="margin-bottom: 0">
            <el-select
              v-model.number="commentParam.level"
              size="small"
              placeholder="评论层级"
              style="width: 100%"
            >
              <el-option :value="null" label="评论层级">--评论层级--</el-option>
              <el-option :value="1" label="父级评论（1级）"
                >父级评论（1级）</el-option
              >
              <el-option :value="2" label="回复评论（2级）"
                >回复评论（2级）</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="是否审核" style="margin-bottom: 0">
            <el-select
              v-model.number="commentParam.status"
              size="small"
              placeholder="是否审核"
              style="width: 100%"
            >
              <el-option
                v-for="(item, idx) in statusList"
                :value="item.value"
                :label="item.label"
                :key="idx"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="是否审核" style="margin-bottom: 0">
            <el-select
              v-model.number="commentParam.status"
              size="small"
              placeholder="是否审核"
              style="width: 100%"
            >
              <el-option
                v-for="(item, idx) in statusList"
                :value="item.value"
                :label="item.label"
                :key="idx"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="评论ID" style="margin-bottom: 0">
            <el-input
              placeholder="请输入评论ID"
              size="small"
              class="param-input"
              style="width: 100%"
              v-model="commentParam.cmtId"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="false">
          <el-form-item label="父级ID" style="margin-bottom: 0">
            <el-input
              placeholder="请输入父级ID"
              size="small"
              class="param-input"
              style="width: 100%"
              v-model="commentParam.pid"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <div class="flex just-between align-item-baseline">
            <div>
              <el-button
                type="success"
                size="small"
                @click="search(commentParam)"
                >搜索
              </el-button>
            </div>
            <div>
              <el-button type="success" size="small" @click="batchComments()"
                >批量审核
              </el-button>
              <el-button type="danger" size="small" @click="cancelComments()"
                >批量取消审核
              </el-button>
              <el-button type="danger" size="small" @click="batchShield(idList)"
                >批量删除
              </el-button>
              <el-button
                type="danger"
                size="small"
                @click="batchShieldByUid(commentParam.uid)"
                >批量删除用户评论
              </el-button>
              <el-button type="primary" size="small" @click="openReason('user')"
                >封禁原因配置
              </el-button>
              <el-button type="primary" size="small" @click="comments()"
                >导入评论内容
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 数据表格  -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="small"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @sort-change="handleSortChange"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      :row-key="getRowKeys"
      highlight-current-row
      height="620"
    >
      <el-table-column
        type="selection"
        align="center"
        disabled="true"
        :selectable="selectable"
        :reserve-selection="true"
        width="55"
      ></el-table-column>
      <el-table-column
        prop="id"
        label="评论ID"
        align="center"
        width="200"
        fixed
      ></el-table-column>
      <el-table-column
        prop="objID"
        label="视频ID"
        align="center"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="userID"
        label="用户ID"
        align="center"
        width="110"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="用户昵称"
        align="center"
        width="110"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="portrait"
        label="用户头像"
        align="center"
        width="90"
      >
        <template slot-scope="scope">
          <img-load
            :width="'32px'"
            :src="
              imgUrl +
              (scope.row.portrait.startsWith('/')
                ? scope.row.portrait
                : '/' + scope.row.portrait)
            "
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="评论内容"
        align="center"
        width="240"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="level"
        label="评论层级"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column prop="cid" label="父ID" align="center" width="200">
        <template slot-scope="scope">
          {{ scope.row.cid == "000000000000000000000000" ? "" : scope.row.cid }}
        </template>
      </el-table-column>
      <el-table-column
        prop="likeCount"
        label="点赞数"
        align="center"
        width="100"
        sortable
      ></el-table-column>
      <el-table-column
        prop="status"
        label="评论状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.status | commentStatus }}({{ scope.row.status }})
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        :show-overflow-tooltip="true"
        width="240"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="430">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            v-if="scope.row.status === 1"
            @click="auditComment(scope.row, 2)"
            >已通过
          </el-button>
          <el-button
            type="danger"
            size="mini"
            v-else
            @click="auditComment(scope.row, 1)"
            >待审核
          </el-button>

          <el-button type="success" size="mini" @click="openComment(scope.row)"
            >回复评论
          </el-button>
          <el-button
            type="warning"
            size="mini"
            v-if="!scope.row.pinned"
            @click="handleToTop(scope.row, true)"
            >未置顶
          </el-button>
          <el-button
            type="danger"
            size="mini"
            v-else
            @click="handleToTop(scope.row, false)"
            >置顶中</el-button
          >
          <el-button
            type="warning"
            size="mini"
            v-if="!scope.row.isBaned"
            @click="banned(scope.row)"
            >禁言
          </el-button>
          <el-button type="info" size="mini" v-else @click="unbanned(scope.row)"
            >解除禁言
          </el-button>
          <el-button
            type="success"
            size="mini"
            @click="access(scope.row.id)"
            v-if="scope.row.status === 3"
            >审核
          </el-button>
          <el-button type="danger" size="mini" @click="removeById(scope.row,scope.$index)"
            >删除
          </el-button>
          <el-button
            v-if="!scope.row.hasLocked"
            type="danger"
            size="mini"
            @click="prohibit(scope.row, 'user')"
            >封禁
          </el-button>
          <!-- <el-button v-else type="primary" size="mini" @click="unprohibit(scope.row)">解封</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="搜索评论内容" :visible.sync="outerVisible" top="20px">
      <el-input
        type="textarea"
        autosize
        placeholder="请输入评论被容"
        width="50%"
        v-model="commentParam.content"
      ></el-input>
      <el-dialog
        title="删除评论内容所在行"
        top="20px"
        :visible.sync="innerVisible"
        append-to-body
      >
        <span>
          {{
            "评论内容为:" +
            commentParam.content +
            "的数据共有" +
            this.total +
            "条"
          }}
        </span>

        <el-button type="text" @click="deleteContent()">删除评论</el-button>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="searchContent">搜索</el-button>
      </div>
    </el-dialog>
    <!--分页组件-->
    <div>
      <el-pagination
        :page-sizes="[5, 10, 20, 30, 50, 100, 200]"
        :current-page="commentParam.pageNumber"
        :page-size="commentParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        v-if="total > commentParam.pageSize"
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
    </div>

    <comment-action
      ref="commentAction"
      @handleList="getCommentList(commentParam, 'status')"
    />
    <import-comments
      ref="importComments"
      @handleList="getCommentList(commentParam, 'status')"
    />
    <!--封禁理由弹窗-->
    <reason-action ref="reasonAction" />
    <select-reason
      ref="selectReason"
      @handleList="getCommentList(commentParam)"
    />
  </div>
</template>
<script>
import API from "@/api";
import {sortEscape} from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import CommentAction from "@/components/commentAction";
import ImportComments from "./components/importComments";
import ReasonAction from "@/components/reasonAction";
import SelectReason from "@/components/selectReasonAction";

export default {
  components: {
    CommentAction,
    ImportComments,
    SelectReason,
    ReasonAction,
  },
  data() {
    return {
      fileList: [],
      statusList: [
        { value: 1, label: "审核通过" },
        { value: 2, label: "未审核" },
        { value: 0, label: "旧版未审核" },
      ],
      outerVisible: false,
      innerVisible: false,
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      idList: [],
      imgUrl: baseConfig.imgUrl,
      uids: [],
      // 是否是机器人
      robotlist: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      //  编辑是选中的评论者
      checkedCommentator: [],
      // 评论管理列表请求参数
      commentParam: {
        pageNumber: 1,
        pageSize: 50,
        key: "",
        value: "",
        level: "",
        cmtId: "",
        pid: "",
        vidID: "",
        uid: "",
        pinned: null,
        content: "",
        isRobot: "",
      },
    };
  },
  created() {
    this.getCommentList(this.commentParam);
  },
  methods: {
    auditComment(row, status) {
      const ids = [];
      ids.push(row.id);
      API.commentReq({ ids: ids, status: status }).then((res) => {
        if (res.code === 200) {
          this.$message.success("审核通过!");
          this.getCommentList(this.commentParam);
        }
      });
    },
    batchComments() {
      const ids = [];
      if (this.idList.length === 0) {
        this.$message.success("请选择一项操作!");
        return;
      }
      this.idList.forEach((item) => {
        ids.push(item);
      });
      API.commentReq({ ids: ids, status: 1 }).then((res) => {
        if (res.code === 200) {
          this.$message.success("审核通过!");
          this.getCommentList(this.commentParam);
        }
      });
    },
    cancelComments() {
      const ids = [];
      if (this.idList.length === 0) {
        this.$message.success("请选择一项操作!");
        return;
      }
      this.idList.forEach((item) => {
        ids.push(item);
      });
      API.commentReq({ ids: ids, status: 2 }).then((res) => {
        if (res.code === 200) {
          this.$message.success("审核通过!");
          this.getCommentList(this.commentParam);
        }
      });
    },
    openComment(row) {
      var cid = row.cid;
      if (cid == "000000000000000000000000") cid = row.id;
      const params = Object.assign(
        {},
        {
          objID: row.objID,
          cid: cid,
          rid: cid,
          toUserID: row.userID,
          level: 2,
          uid: row.userID,
        }
      );
      this.$refs.commentAction.open(params);
    },
    // eslint-disable-next-line no-unused-vars
    handleRemove(file, fileList) {},
    // eslint-disable-next-line no-unused-vars
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // eslint-disable-next-line no-unused-vars
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 封禁原因配置
    openReason(type) {
      this.$refs.reasonAction.open(type);
    },
    // 点击封禁按钮打开弹窗
    prohibit(row, type) {
      this.$refs.selectReason.open(row, type);
    },
    // 封禁用户
    // prohibit(row, type) {
    //   if (type === "batch") {
    //     if (!this.uids) {
    //       this.$message.error("封禁的用户不能少于一个");
    //       return;
    //     }
    //     this.$confirm("您确定要批量封禁用户吗？", "封禁提示", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //     }).then(() => {
    //       let params = {
    //         uidList: this.uids,
    //         enable: true,
    //       };
    //       this.lockUser(params);
    //     });
    //   } else {
    //     this.$confirm("您确定要封禁当前用户吗？", "封禁提示", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //     })
    //       .then(() => {
    //         let params = {
    //           uidList: [row.userID],
    //           enable: true,
    //         };
    //         this.lockUser(params);
    //       })
    //       // eslint-disable-next-line no-unused-vars
    //       .catch((_) => {});
    //   }
    // },
    // 解禁用户
    // unprohibit(row) {
    //   this.$confirm("您确定要解封当前用户吗？", "解封提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(() => {
    //       let params = {
    //         uidList: [row.userID],
    //         enable: false
    //       };
    //       this.lockUser(params);
    //     })
    //     // eslint-disable-next-line no-unused-vars
    //     .catch(_ => {});
    // },
    // 封禁
    lockUser(params) {
      // eslint-disable-next-line no-console
      // console.log(params);
      API.getUserLock(params)
        .then((res) => {
          if (res.code === 200) {
            if (params.enable) {
              this.$message({
                message: "封禁用户成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "解封用户成功",
                type: "success",
              });
            }
            this.getCommentList(this.commentParam);
          }
        })
        .catch(() => {});
    },

    // 删除当前评论
    deleteComment(row) {
      this.remove([row.id], "");
    },
    // 批量删除
    batchShieldByUid(uid) {
      if (uid === "") {
        this.$message.error("输入要删除的用户UID");
        return;
      }
      this.remove([], uid);
    },

    // 批量删除
    batchShield(idList) {
      if (idList.length === 0) {
        this.$message.error("至少选择一条数据进行操作");
        return;
      }
      this.remove(idList, "");
    },

    // 获取批量操作数据id
    handleSelectionChange(row) {
      var arr = [];
      row.forEach(function (item) {
        arr.push(item.id);
      });
      this.idList = arr;
    },

    getTrDom(dom) {
      if (dom.tagName.toLowerCase() == "tr") {
        return dom;
      }
      return this.getTrDom(dom.parentElement);
    },

    // 删除当前评论请求
    remove(id, uid) {
      this.$confirm("删除该评论将不允许恢复，确认删除？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = uid === "" ? { ids: id } : { uid: Number(uid) };
        API.delComment(params)
          .then((res) => {
            if (res.code === 200) {
              if (uid) this.commentParam.uid = "";
              this.getCommentList(this.commentParam);
              this.$message({
                message: uid
                  ? "用户UID【" + uid + "】下的评论全部删除成功！"
                  : "删除成功！",
                type: "success",
              });
            } else {
              this.$message.error("删除失败！");
            }
          })
          .catch(() => {
            this.$message.error("删除失败！");
          });
      });
    },

    // 删除当前评论请求
    removeById(row,index) {
      this.$confirm("删除该评论将不允许恢复，确认删除？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { id: row.id };
        API.delCommentId(params)
          .then((res) => {
            if (res.code === 200) {
              this.tableData.splice(index,1)
              if( this.tableData.length == 0)this.getCommentList(this.commentParam);
              this.$message({
                message: "删除成功！",
                type: "success",
              });
            } else {
              this.$message.error("删除失败！");
            }
          })
          .catch(() => {
            this.$message.error("删除失败！");
          });
      });
    },

    // 根据评论内容批量删除
    deleteContent() {
      this.$confirm(
        "删除该评论将不允许恢复，确认删除？",
        "删除提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
        this.getCommentList(this.commentParam)
      ).then(() => {
        // let params = uid === "" ? { ids: id } : { uid: Number(uid) };
        let params = Object.assign({}, this.params, {
          content: this.commentParam.content,
          idList: this.idList,
          uids: this.uids,
        });
        API.deleteContent(params)
          .then((res) => {
            if (res.code === 200) {
              // this.remove(this.idList, this.uid);
              this.$message({
                message: "删除成功！",
                type: "success",
              });
            } else {
              this.$message.error("删除失败！");
              this.outerVisible = false;
            }
          })
          .catch(() => {
            this.$message.error("删除失败！");
            this.outerVisible = false;
          });
      });
    },
    // deleteContent() {
    //   API.deleteContent({
    //     content: this.commentParam.content,
    //     idList: "",
    //     uid:this.commentParam.uid
    //   }).then(res => {
    //     this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning"
    //     })
    //       .then(() => {
    //         this.$message({
    //           type: "success",
    //           message: "删除成功!"
    //         });
    //       })
    //       .catch(() => {
    //         this.$message({
    //           type: "info",
    //           message: "已取消删除"
    //         });
    //       });
    //   });

    // },
    // deleteContent(conten,idList,uid) {
    //    this.content=this.commentParam.content;
    //     this.idList='';
    //     this.uid=this.commentParam.uid;
    //     this.remove(conten,idList,uid);

    //   },
    getRowKeys(row) {
      return row.id;
    },
    // 设置表格默认选中
    setSelectRow() {
      if (!this.checkedCommentator || this.checkedCommentator.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      let selectAllIds = [];
      this.checkedCommentator.forEach((row) => {
        selectAllIds.push(row["id"]);
      });
      for (var i = 0; i < this.tableData.length; i++) {
        selectAllIds.forEach((item) => {
          if (this.tableData[i].id === item) {
            this.$refs.multipleTable.toggleRowSelection(
              this.tableData[i],
              true
            );
          }
        });
      }
    },

    // 搜索对应列表
    search() {
      this.commentParam.pageNumber = 1;
      this.getCommentList(this.commentParam);
    },

    //根据评论内容搜索
    searchContent() {
      this.innerVisible = true;
      this.commentParam.pageNumber = 1;
      this.getCommentList(this.commentParam);
    },
    // 禁止选择勾选框
    selectable(row) {
      if (row.isDelete) {
        return false;
      } else {
        return true;
      }
    },
    // 请求禁言或解禁用户
    banUser(params) {
      API.getUserBan(params).then((res) => {
        if (res.code === 200) {
          if (params.enable) {
            this.$message({
              message: "禁言用户成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "解除禁言成功",
              type: "success",
            });
          }
          this.search();
        }
      });
    },
    // 禁言用户
    banned(row) {
      this.$confirm("您确定要禁言当前用户？", "禁言提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          uidList: [row.userID],
          enable: true,
        };
        this.banUser(params);
      });
    },
    handleToTop(val, flag) {
      this.$confirm(
        flag ? "您确定要置顶当前评论吗？" : "您确定要取消置顶当前评论吗",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let params = {
          id: val.id,
          pinned: flag,
        };
        API.toTOP(params).then((res) => {
          if (res.code === 200) {
            val.pinned = flag;
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "置顶失败",
              type: "info",
            });
          }
        });
      });
    },
    // 解除禁言用户
    unbanned(row) {
      this.$confirm("您确定要解除当前用户禁言？", "解除禁言提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uidList: [row.userID],
            enable: false,
          };
          this.banUser(params);
        })
        .catch(() => {});
    },
    // 审核状态
    access(id) {
      this.$confirm("是否通过该条评论？", "审核提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.getCommentAccess({ id: id })
          .then((res) => {
            if (res.code === 200) {
              this.getCommentList(this.commentParam);
              this.$message({
                message: "审核通过",
                type: "success",
              });
            } else {
              this.$message.error("审核未通过");
            }
          })
          .catch(() => {
            this.$message.error("审核未通过");
          });
      });
    },
    // 请求评论模块配置列表
    getCommentList(params, type) {
      if (type === "status") {
        this.commentParam.pageNumber = 1;
      }
      this.loading = true;
      API.getCommentList(params)
        .then((res) => {
          this.loading = false;
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            this.uids = res.data.uids;
            this.setSelectRow();
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          this.loading = false;
          this.tableData = [];
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.commentParam.value = sortEscape(column.order);
      this.commentParam.key = column.prop;
      this.getCommentList(this.commentParam);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.commentParam.pageSize = size;
      this.commentParam.pageNumber = 1;
      this.getCommentList(this.commentParam);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.commentParam.pageNumber = pageNumber;
      this.getCommentList(this.commentParam);
    },

    //导入评论内容
    comments() {
      this.$refs.importComments.open();
    },
  },
};
</script>

<style lang="scss">
.commentList {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
